(() => {
  const initialize = (roadClosuresList) => {
    const element = roadClosuresList.element;
    const options = JSON.parse(roadClosuresList.options);
    const headers = element.querySelectorAll('thead th');

    fetch(options.apiURL).then((data) => {
      data.json().then((jsonResponse) => {
        jsonResponse.features.forEach((road) => {
          const template = element.querySelector('.road-closures-list__template');
          const clone = template.content.cloneNode(true);
          const td = clone.querySelectorAll('td');

          Array.from(headers).map((header, index) => {
            let value = header.dataset.date === 'true' ? new Date(road.attributes[header.dataset.key]).toDateString() : road.attributes[header.dataset.key];

            td[index].textContent = value;
          });

          element.querySelector('.road-closures-list__body').appendChild(clone);
        });
      });
    });
  };

  const roadClosuresList = stp.setup('road-closures-list');

  roadClosuresList.map(initialize);
})();
